import React from 'react'
import {Provider} from '../context/Context';
import Grid, {kGridProjects} from "../components/Grid";

const ProjectsTemplate = (props) => {

    return (
        <Provider router={props}>
            <Grid filter={kGridProjects}/>
        </Provider>
    )

};

export default ProjectsTemplate;